import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import {getItemWithExpiry} from "@/store/localstoragewithexpire";

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
let token = getItemWithExpiry('token')
if (token) {
    store.commit("set_token", token)
}
const routes = [
    // 首页
    {
        path: '/',
        name: 'index',
        component: function () {
            return import('../views/index/index.vue')
        }
    },
    // 课程中心
    {
        path: '/category',
        name: 'category',
        component: function () {
            return import('../views/category/category.vue')
        }
    },
    // 课程详情
    {
        path: '/category/detail',
        name: 'categoryDetail',
        component: function () {
            return import('../views/category/detail.vue')
        }
    },
    // 热点阅读
    {
        path: '/article',
        name: 'article',
        component: function () {
            return import('../views/article/article.vue')
        }
    },
    // 热点阅读详情
    {
        path: '/article/detail',
        name: 'articleDetail',
        component: function () {
            return import('../views/article/detail.vue')
        }
    },
    // 信息发布
    {
        path: '/activity',
        name: 'activity',
        component: function () {
            return import('../views/activity/activity.vue')
        }
    },
    // 信息发布详情
    {
        path: '/activity/detail',
        name: 'activityDetail',
        component: function () {
            return import('../views/activity/detail.vue')
        }
    },
    // 个人中心
    {
        path: '/personal',
        name: 'personal',
        component: function () {
            return import('../views/personal/personal.vue')
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router